module.exports = __webpack_public_path__ + "media/images/home/fv_present_md-b671a1d8994e9cd168278533986e1b61.png";